/**
 * Generic queue-count tile: title + count + deep link.
 *
 * Backend tiles `queue_reports`, `queue_feedback`, `queue_photos`,
 * `queue_flagged` all share the shape { count: number }. The frontend
 * routes each to a different deep link.
 */
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { formatNumber } from '@/lib/utils';

interface Props {
  title: string;
  count: number;
  link: string;
}

export function QueueTile({ title, count, link }: Props) {
  return (
    <Link
      to={link}
      className="bg-card border rounded-lg p-4 hover:bg-accent transition-colors group"
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs text-muted-foreground uppercase tracking-wide">{title}</div>
          <div className="text-2xl font-semibold mt-1">{formatNumber(count)}</div>
        </div>
        <ExternalLink className="h-3 w-3 text-muted-foreground opacity-0 group-hover:opacity-100" />
      </div>
      <div className="text-xs text-muted-foreground mt-2">Open queue →</div>
    </Link>
  );
}
